// extracted by css-extract-rspack-plugin
export default {"filterCardsWrap":"FilterCardList_filterCardsWrap__yaki8"};